import { Stack } from '@mui/material';
import { TrainingMaterialProvider } from './contexts/TrainingMaterialContext';
import TrainingMaterialsTop from './components/TrainingMaterialsTop';
import TrainingMaterials from './components/TrainingMaterials';
import PageArea from '../../components/shared/PageArea';
import TrainingAreaPopUps from './components/TrainingAreaPopUps';

const TrainingMaterial=() => {
  return (
    <TrainingMaterialProvider>
      <PageArea>
        <Stack spacing={5}>
          <TrainingMaterialsTop/>
          <TrainingMaterials/>
        </Stack>
        <TrainingAreaPopUps/>
      </PageArea>
    </TrainingMaterialProvider>
  );
};

export default TrainingMaterial;
